export const WALLET_ADDRESS_REGEX = /^(0x)?[0-9a-fA-F]{40}$/;
